
$( document ).ready(function() {

  $(".product_optiontab .first_options li").click(function() {
      $(".first_options li.active_tabs").removeClass("active_tabs"); 
     $(this).addClass("active_tabs"); 
  });
  $(".product_optiontab .second_options li").click(function() {
      $(".second_options li.active_tabs").removeClass("active_tabs"); 
     $(this).addClass("active_tabs"); 
  
  });

  $(".product_loopblock .add_to_cart").click(function(e) {
    
    e.preventDefault();
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    var SwymGrVarId = $(this).find('form [name="id"]').val();
    var SwymGrVarQty = $(this).find('form [name="quantity"]').val();
    var SwymGrVarSellingId = $(this).find('form [name="selling_plan"]').val();

    data = {
      "id": SwymGrVarId,
      "quantity": SwymGrVarQty,
      "selling_plan": SwymGrVarSellingId
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function(response) { 
        console.log(response)
        $('a.header__action-item-link.header__cart-toggle').trigger('click');
        $('.header__cart-toggle').attr('aria-expanded', true);
        $('.mini-cart').attr('aria-hidden',false);
        //window.location.href = '/cart'; 
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        $.getJSON('/cart.js', function(cart) { 
			var result = cart.item_count;
			console.log(result);
            setTimeout (function() {
              $('#SwymGrCartCount').text(result);
            },100);
          
            setTimeout (function() {
              $('#SwymGrCartCount').text(result);
            },1200);
		});
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      },
      error: function(error) { 
        //window.location.href = '/cart'; 
        console.log(error);
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      }
    });
     return false;

    
    });



    $(document).on('click', '.itg_subscription-customized-online-wine-subscription-box .button', function() {
      $('html, body').animate({
          scrollTop: ($("#membar_ships").offset().top - 100)
      }, 100);
    });

 
  });




$(document).on('click', '.product_optiontab li', function() {
  var option1 =  $('.first_options .active_tabs').find('a').attr('value');
  var option2 = $('.second_options .active_tabs').find('a').attr('value');
  var Combination = option1 + ' ' + option2;
  $(document).find('.SwymGrProduct').each(function() {
    var VariantId = $(this).find('select.ssoo').find('option[vartitle="'+Combination+'"]').attr('value');
    var VariantPrice = $(this).find('select.ssoo').find('option[vartitle="'+Combination+'"]').attr('data-price');
    $(this).find('form [name="id"]').val(VariantId);
     $(this).find('.product_main_divblock .product_price h1').html(VariantPrice);
      console.log($(this).find('select.ssoo option[vartitle="'+Combination+'"]').attr('vartitle'));
      console.log(VariantId);
  });
});

setTimeout(function(){
  $('.itg_subscription-customized-online-wine-subscription-box .image-text-section .border_svg svg').show();
}, 1000 )




